import React from 'react';
import PageTitle from '../PageTitle';
import $ from 'jquery';
import renderHTML from 'react-render-html';
import { doRequest } from '../../helper';

export default class FitIndiaAddVideo extends React.Component {
    constructor() {
        super();
        this.state = {
            video: null
        }
        this.getYoutube = this.getYoutube.bind( this );
        this.saveVideo = this.saveVideo.bind( this );
    }
    getYoutube( event ) {
        var ref = this;
        var url = event.target.value;
        $.ajax( {
            url: 'https://query.yahooapis.com/v1/public/yql',
            data: {
                q: "select * from json where url ='http://www.youtube.com/oembed?url=" + url + "&format=json'",
                format: "json"
            },
            dataType: "jsonp",
            success: function( data ) {
                if ( data.query && data.query.results ) {
                    var video = data.query.results.json;
                    $( "#youtubeVideoTitle" ).val( video.title );
                    ref.setState( { "video": video } );
                }
            },
            error: function( result ) {
                alert( "Sorry no data found." );
            }
        } );

    }

    saveVideo() {
        var ref = this;
        var title = this.title.value;
        if ( $.trim( title ) != "" && this.state.video ) {

            var video = this.state.video;
            video['customTitle'] = title; //updating the title in the video object
            video['url'] = this.url.value;
            var proceed = true;
            if ( $.trim( this.description.value ) == "" ) {
                proceed = window.confirm( "Do you want to save video without description ?" );
            } else {
                video['description'] = this.description.value;
            }
            if ( proceed ) {
                $( ".loader" ).show();
                var payload = {
                    'action': 'save-video',
                    'module': 'FitIndia',
                    'model': 'video',
                    'data': {
                        'video': video,
                        'yoga': 0,
                        'yogaSpeech': 0,
                        'trending': 0
                    }
                };
                var otherFlags = [];
                if ( this.pmSpeech.checked ) {
                    otherFlags.push( { 'otherFlag': 'pmSpeech', 'otherFlagValue': 1 } )
                }
                if ( this.yogaSpeech.checked ) {
                    otherFlags.push( { 'otherFlag': 'yogaSpeech', 'otherFlagValue': 1 } )
                }
                if ( this.yoga3d.checked ) {
                    otherFlags.push( { 'otherFlag': 'yoga3d', 'otherFlagValue': 1 } )
                }
                
                payload['data']['otherFlags'] = otherFlags;
                var request = doRequest( 'cms-operations', payload, true );

                request.addEventListener( "load", function() {

                    $( ".loader" ).hide();
                    var response = this.responseText;
                    try {
                        response = JSON.parse( response );
                        if ( response._resultflag && response._resultflag == 1 ) {
                            alert( 'Video Saved' )
                            ref.title.value = '';
                            ref.description.value = '';
                            ref.url.value = '';
                        }
                    } catch ( ex ) {
                        alert( 'Video can not be addded, please try again !' )

                    }

                } );

            }
        }
    }

    render() {
        var video = this.state.video;
        return (
            <div><PageTitle title="Fit India Campaign" bread="Fit India Campaign / Add Video" />
                <div className="wrapper wrapper-content">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ibox float-e-margins">
                                <div className="ibox-title">
                                    <h5>Add Youtube Video <small> Add New Video</small></h5>
                                    <div className="ibox-tools">
                                        <a className="collapse-link">
                                            <i className="fa fa-chevron-up"></i>
                                        </a>

                                    </div>
                                </div>
                                <div className="ibox-content">
                                    <div className="row">
                                        <div className="col-sm-6 b-r">

                                            <div className="form-group"><label>Link</label> <input ref={( url ) => { this.url = url }} onChange={this.getYoutube} type="text" placeholder="Enter youtube link" className="form-control" /></div>
                                            <div className="form-group"><label>Title</label> <input ref={( title ) => { this.title = title }} id="youtubeVideoTitle" type="test" placeholder="Video Title" className="form-control" /></div>
                                            <div className="form-group"><label>Description</label> <textarea ref={( description ) => { this.description = description }} placeholder="Description" className="form-control" ></textarea></div>
                                            <div className="form-group checkbox">
                                                <label>
                                                    <input type="checkbox" ref={( yogaSpeech ) => { this.yogaSpeech = yogaSpeech }} value="" />
                                                    Yoga Speech
                                                                </label>&nbsp;&nbsp; | &nbsp;&nbsp;
                                                <label>
                                                    <input type="checkbox" ref={( yoga3d ) => { this.yoga3d = yoga3d }} value="" />
                                                    Yoga 3D
                                                                            </label>&nbsp;&nbsp; | &nbsp;&nbsp;
                                                <label>
                                                    <input type="checkbox" ref={( pmSpeech ) => { this.pmSpeech = pmSpeech }} value="" />
                                                    PM Speech
                                                                </label>
                                            </div>
                                            <div>
                                                <button className="btn btn-sm btn-primary pull-right m-t-n-xs" type="submit" onClick={this.saveVideo}>
                                                    <strong>Save Video</strong></button>

                                            </div>

                                        </div>


                                        {video ?
                                            <div className="col-sm-6"><p className="text-center">
                                                {renderHTML( video.html )}
                                            </p> </div> : ""}



                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div > );
    }
}


// WEBPACK FOOTER //
// ./src/Components/FitIndia/AddVideo.jsx